import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.state === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center text-ink-muted">
        Signing in…
      </div>
    );
  }
  if (auth.state === 'signedOut') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
